import { HawkSearchComponents, SearchResultsItem, SearchResultsListComponentConfig, SearchResultsListComponentModel } from '@models';
import { BaseComponent } from '../../base.component';
import { SearchResultsItemComponent } from '../search-results-item/search-results-item.component';
import defaultHtml from './search-results-list.component.hbs';

export class SearchResultsListComponent extends BaseComponent<SearchResultsListComponentConfig, Array<SearchResultsItem>, SearchResultsListComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'search-results-list';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = true;

    protected override renderContent(): boolean {
        return !!this.data?.length;
    }

    protected override getContentModel(): SearchResultsListComponentModel {
        return {
            items: this.data!
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll<SearchResultsItemComponent>('hawksearch-search-results-item').forEach((component, index) => {
            component.data = this.data?.[index];
        });
    }
}
